import { __rest, __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { SIZE_TO_CLASSNAME_MAP } from '../../consts.js';
import { Content } from './Component.js';

var styles = {"size-500":"side-panel__size-500_9ht8g"};
require('./desktop.css')

var ContentDesktop = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 500 : _b, className = _a.className, restProps = __rest(_a, ["size", "className"]);
    return (React.createElement(Content, __assign({ className: cn(className, size && styles[SIZE_TO_CLASSNAME_MAP[size]]) }, restProps)));
};

export { ContentDesktop };
